import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyA3jJRZdwdngGT6G-VxrFzunHLZLf5qCyY",
  // Use the production custom domain so email sign-in links use:
  // https://survey.cyberireland.ie/__/auth/action?... rather than the default
  // https://<project>.firebaseapp.com/__/auth/action?...
  authDomain: "survey.cyberireland.ie",
  projectId: "csecireland",
  storageBucket: "csecireland.firebasestorage.app",
  messagingSenderId: "40325793847",
  appId: "1:40325793847:web:70c6ec9af61509dfd657b2",
  measurementId: "G-WR9M2ZG39T",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
